import * as React from 'react';
import styled from 'styled-components';
import ReactDOM from 'react-dom';

interface IModalShowModal {
  component: React.FC | React.ReactNode | null;
}

interface IModalContext {
  hideModal: () => void;
  showModal: (args: IModalShowModal) => void;
  showFeedback: (args: IModalShowModal) => void;
  show: boolean;
  component: React.FC | React.ReactNode | null;
}

export const ModalContext = React.createContext<IModalContext>({
  hideModal: () => {},
  showModal: () => {},
  showFeedback: () => {},
  show: false,
  component: null,
});

export const ModalContextProvider: React.FC = ({ children }) => {
  const [show, setShow] = React.useState(false);

  const [component, setComponent] = React.useState<
    React.FC | React.ReactNode | null
  >(null);

  const hideModal = () => {
    setShow(false);
    setComponent(null);
  };
  const showModal = (args: IModalShowModal) => {
    setShow(true);
    setComponent(args.component);
  };

  const showFeedback = (args: IModalShowModal) => {
    setShow(true);
    setComponent(args.component);
  };

  return (
    <ModalContext.Provider
      value={{ show, component, hideModal, showModal, showFeedback }}
    >
      {children}
    </ModalContext.Provider>
  );
};

const ModalOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  top: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 999;
`;

const ModalContainer = styled.div`
  position: absolute;
  z-index: 1000;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;

export const Modal: React.FC = () => {
  const { show, component } = React.useContext(ModalContext);

  const Portal = () => {
    return (
      <>
        <ModalContainer>{component}</ModalContainer>
        <ModalOverlay />
      </>
    );
  };

  if (typeof window !== 'undefined') {
    const portals = document.getElementById('portals');
    if (portals && show && component) {
      return ReactDOM.createPortal(<Portal />, portals);
    }
    return null;
  }
  return null;
};
